import { render, staticRenderFns } from "./CrudConfigs.vue?vue&type=template&id=70a2108a&scoped=true&"
import script from "./CrudConfigs.vue?vue&type=script&lang=js&"
export * from "./CrudConfigs.vue?vue&type=script&lang=js&"
import style0 from "./CrudConfigs.vue?vue&type=style&index=0&id=70a2108a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2108a",
  null
  
)

export default component.exports